export const COMPANY = {
  name: "Polycaps Tech Plast",
  legal: "Polycaps Tech Plast Pvt. Ltd.",
  phone1: "+91 98233 77330",
  phone1raw: "+919823377330",
  phone2: "+91 90217 83874",
  phone2raw: "+919021783874",
  email: "polycapstechplast@gmail.com",
  poc: "Jayesh Sejpal",
  address: "C17, Navkar Industrial Estate & Logistics Park, Mahalgoan, Nagpur — 441104",
};

export const ASSETS = {
  logo:
    "https://customer-assets-0z36b82j.emergentagent.net/job_polycaps-profile/artifacts/5ep8vgg4_IMG_1876.jpeg",
  logoDark:
    "https://static.prod-images.emergentagent.com/jobs/23882ab5-69a9-4f44-9373-5fe17b238f1f/images/fa66cf24340b5da680a188e163f7d9fbc60862389e9fc6fb09b9c11f2a4fde1a.jpeg",
  logoWhite:
    "https://static.prod-images.emergentagent.com/jobs/23882ab5-69a9-4f44-9373-5fe17b238f1f/images/675195504a88ee18356c19a4bf9d30329e9bea3d62b41275ca48ffc3e957bba2.jpeg",
  heroCap:
    "https://static.prod-images.emergentagent.com/jobs/23882ab5-69a9-4f44-9373-5fe17b238f1f/images/2c65d316ddbdaa475fbb1a580018425680b2d2c7f32898329707ffeb456de285.jpeg",
  capMacro: "/alaska-cap.jpg",
  capsFlow:
    "https://static.prod-images.emergentagent.com/jobs/23882ab5-69a9-4f44-9373-5fe17b238f1f/images/1d18e427782a4b337e8ae58d420f4142c9a448a669b999e2b96eb2b81bcf1d5d.jpeg",
  factory: "/facility-machine.jpg",
  factory2:
    "https://images.unsplash.com/photo-1717386255773-1e3037c81788?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  bottleCaps:
    "https://images.pexels.com/photos/10376368/pexels-photo-10376368.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1600",
};

export const CHAPTERS = [
  {
    no: "01",
    title: "Engineered for the food & beverage industry.",
    body:
      "We set the benchmark for high-quality plastic caps and closures — engineered specifically for the diverse needs of food and beverage brands. Every closure delivers innovation, safety and reliability that protects product integrity.",
  },
  {
    no: "02",
    title: "Hygiene, freshness and safety are the whole point.",
    body:
      "Every cap we produce is a testament to rigorous quality control, adherence to international standards, and premium food-grade materials — because in this industry, safety isn't a feature, it's the foundation.",
  },
  {
    no: "03",
    title: "Partnerships over transactions.",
    body:
      "We see clients not as transactional partners but as allies in a shared journey of growth. By understanding your unique goals, we craft tailored solutions — from custom color work to high-volume production — that let your organization thrive.",
  },
];

export const MISSION = [
  {
    t: "Uncompromised Quality & Safety",
    d: "Delivering product quality and safety with zero shortcuts — every cap passes SACMI vision inspection before it ships.",
  },
  {
    t: "Sustainable Manufacturing",
    d: "Promoting eco-conscious production practices across the molding floor, not as an afterthought.",
  },
  {
    t: "Community & Responsibility",
    d: "Driving social responsibility and community engagement alongside the business itself.",
  },
];

export const VALUES = [
  { t: "Innovation", d: "Continuously exploring new materials and designs to meet evolving market demands." },
  { t: "Quality Assurance", d: "Implementing stringent checks at every stage of production to guarantee superior products." },
  { t: "Customer Focus", d: "Building lasting partnerships by understanding and addressing unique client requirements." },
];

export const SPECS = [
  { k: "Type", v: "Compression-molded closure" },
  { k: "Material", v: "High-Density Polyethylene (HDPE)" },
  { k: "Weight", v: "1.3 grams" },
  { k: "Compatibility", v: "28mm PET preform" },
  { k: "Packaging", v: "8,000 pcs / carton" },
  { k: "Inspection", v: "100% SACMI vision" },
];

export const PRODUCT_FEATURES = [
  { t: "Premium Finish", d: "Enhances brand image and consumer appeal." },
  { t: "Leak-Proof", d: "Ensures product integrity and prevents spills." },
  { t: "Food-Grade", d: "Compliant with strict food safety standards." },
  { t: "Automated Inspection", d: "100% vision inspection for defect-free products." },
];

export const CAPABILITIES = [
  { k: "25,000", u: "sq. ft.", d: "State-of-the-art manufacturing premises" },
  { k: "100%", u: "vision", d: "SACMI (Italy) inspection on every cap" },
  { k: "In-house", u: "end-to-end", d: "From design to final packaging" },
  { k: "2023", u: "GST reg.", d: "Built around one job, done right" },
];
